import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/functions';
import NFTStore from '@poolside-fm/nft-store';
import __$_require_is_safari__ from 'is-safari';

//

var script = {
  name: "ConnectNft",
  props: {
    subtitle: String,
    requireSigning: { type: Boolean, default: false },
  },
  data: function () {
    return {
      STATE: NFTStore.STATE,
      connecting: false,
      disconnecting: false,
      signing: false,
      signed: false,
      firebaseUser: false,
    };
  },
  computed: {
    user: function user() {
      return this.$store.getters.user ? this.$store.getters.user : false;
    },
    primaryNFTType: function primaryNFTType() {
      return (
        (!this.requireSigning || this.firebaseUser) &&
        this.$store.getters["nft/primaryNFTType"]
      );
    },
    userNFTs: function userNFTs() {
      return (
        (!this.requireSigning || this.firebaseUser) &&
        this.$store.getters["nft/userNFTs"]
      );
    },
    userAddress: function userAddress() {
      return this.$store.getters["nft/userAddress"];
    },
    error: function error() {
      return this.$store.getters["nft/error"];
    },
    connectionState: function connectionState() {
      return this.$store.getters["nft/connectionState"];
    },
    isEthereumOnlyUser: function isEthereumOnlyUser() {
      return this.$store.getters["nft/isEthereumOnlyUser"];
    },
  },
  watch: {
    connectionState: async function connectionState(newState) {
      var this$1 = this;

      if (this.connecting && newState === this.STATE.DISCONNECTED) {
        // we had some error
        this.connecting = false;
        this.$store.dispatch("nft/reset");
        this.$store.commit("nft/setMonitoringNFTState", true);
      }
      if (this.connecting && this.connectionState == this.STATE.READY) {
        this.connecting = false;
        if (!this.requireSigning) {
          this.$store.commit("nft/setMonitoringNFTState", true);
          this.$emit("walletConnected");
          return;
        }

        this.signing = true;
        var ref = await this.$store.dispatch(
          "nft/signPoolsuiteMessage"
        );
        var signature = ref.signature;
        if (!signature) {
          this.signing = false;
          return;
        }

        var connectWalletToUser = firebase
          .app()
          .functions()
          .httpsCallable("connectWalletToUser");
        connectWalletToUser({
          ethereumAddress: this.userAddress,
          signature: signature,
        })
          .then(function (response) {
            this$1.signed = true;
            if (response && response.data && response.data.loginToken) {
              // If we have a login token, sign in with it
              if (firebase.auth().currentUser) {
                console.log(
                  "?? Got a login token but user is already logged in."
                );
              } else {
                // Get a user credential before reloading
                firebase
                  .auth()
                  .signInWithCustomToken(response.data.loginToken)
                  .then(function () {
                    return this$1.$emit("walletConnected");
                  });
              }
            } else {
              // Otherwise just return connected (the user account should be linked now)
              return this$1.$emit("walletConnected");
            }
          })
          .catch(function () {})
          .finally(function () {
            this$1.$store.commit("nft/setMonitoringNFTState", true);
            this$1.signing = false;
          });
      }
      if (
        this.disconnecting &&
        this.connectionState === this.STATE.DISCONNECTED
      ) {
        if (firebase.auth().currentUser) {
          // If we are a wallet-only user, logout
          var token = await firebase.auth().currentUser.getIdTokenResult();
          if (token && token.claims.is_ethereum_user) {
            await firebase.auth().signOut();
          }
        }
        this.disconnecting = false;
        this.$emit("walletDisconnected");
      }
    },
  },
  mounted: function () {
    var this$1 = this;

    if (!firebase.apps.length) {
      return;
    }
    firebase.auth().onAuthStateChanged(function (user) {
      user ? (this$1.firebaseUser = true) : (this$1.firebaseUser = false);
    });
    firebase.auth().currentUser
      ? (this.firebaseUser = true)
      : (this.firebaseUser = false);
  },
  methods: {
    connectNFT: async function connectNFT(type) {
      this.connecting = true;
      this.$store.commit("nft/setMonitoringNFTState", false);
      this.$store.dispatch("nft/connectNFT", type);
    },
    disconnectNFT: async function disconnectNFT() {
      this.disconnecting = true;
      this.$store.dispatch("nft/disconnectNFT");
    },
    logout: async function logout() {
      if (firebase.auth().currentUser) {
        await firebase.auth().signOut();
      }
      this.$emit("walletDisconnected");
    },
    closeComponent: function closeComponent() {
      this.$emit("closeConnectComponent");
    },
  },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__ = script;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "inner-wrapper poolsuite-connect-component" },
    [
      _c(
        "button",
        {
          staticClass: "connect-component-close",
          on: { click: _vm.closeComponent },
        },
        [_c("span", [_vm._v("Close")])]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.user
        ? _c("h2", [
            _vm._v("\n    EXECUTIVE MEMBER "),
            _c("br"),
            _vm._v("\n    LEISURE ACCESS\n  ") ])
        : _c("h2", [
            _vm._v("\n    LOG IN WITH THE "),
            _c("br"),
            _vm._v("\n    POWER OF THE WEB III\n  ") ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm.error
        ? [
            _c("p", {
              staticClass: "nft-error",
              domProps: { innerHTML: _vm._s(_vm.error) },
            }) ]
        : _vm.user
        ? _c("p", [
            _vm._v("\n    Unlock a new world of corporate excess with "),
            _c("br"),
            _vm._v("your Poolsuite Executive\n    Member NFT.\n  ") ])
        : _c(
            "p",
            [
              _vm.subtitle
                ? _c("span", { domProps: { innerHTML: _vm._s(_vm.subtitle) } })
                : [
                    _vm._v(
                      "\n      Connect your Ethereum wallet to login to Poolsuite."
                    ),
                    _c("br"),
                    _vm._v("No electronic\n      mail address needed!\n    ") ] ],
            2
          ),
      _vm._v(" "),
      this.requireSigning && this.signing && !this.signed
        ? [
            _vm.connectionState === _vm.STATE.PREPARING_MESSAGE
              ? _c("p", [_vm._v("\n      Preparing signing message...\n    ")])
              : _vm.connectionState === _vm.STATE.SIGNING_MESSAGE
              ? _c("p", [_vm._v("\n      Waiting for signature...\n    ")])
              : _c("p", [_vm._v("Connecting, please wait...")]) ]
        : _vm.connectionState === _vm.STATE.REQUESTING_WALLET ||
          _vm.connectionState === _vm.STATE.LOGGING_IN ||
          _vm.connectionState === _vm.STATE.GETTING_USER_INFO
        ? [_c("p", [_vm._v("Connecting, please wait...")])]
        : [
            !_vm.primaryNFTType
              ? _c("div", { staticClass: "button-wrapper" }, [
                  !__$_require_is_safari__
                    ? _c(
                        "button",
                        {
                          staticClass: "login-button do-not-invert",
                          on: {
                            click: function ($event) {
                              return _vm.connectNFT("metaMask")
                            },
                          },
                        },
                        [_vm._m(2)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "login-button do-not-invert",
                      on: {
                        click: function ($event) {
                          return _vm.connectNFT("walletConnect")
                        },
                      },
                    },
                    [_vm._m(3)]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "login-button do-not-invert",
                      on: {
                        click: function ($event) {
                          return _vm.connectNFT("walletLink")
                        },
                      },
                    },
                    [_vm._m(4)]
                  ) ])
              : _c("div", { staticClass: "button-wrapper" }, [
                  _vm.isEthereumOnlyUser
                    ? _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "login-button do-not-invert",
                            on: { click: _vm.logout },
                          },
                          [_c("span", [_vm._v("Log Out")])]
                        ) ])
                    : _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "login-button do-not-invert",
                            on: { click: _vm.disconnectNFT },
                          },
                          [
                            _vm.connectionState === _vm.STATE.DISCONNECTING
                              ? _c("span", [_vm._v("Disconnecting...")])
                              : _c("span", [_vm._v("Disconnect NFTs")]) ]
                        ) ]) ]) ] ],
    2
  )
};
var __vue_staticRenderFns__ = [
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "lines" }, [
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span") ])
  },
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "lines" }, [
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span") ])
  },
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("span", { staticClass: "button-login-inner" }, [
      _c("span", [_vm._v("MetaMask")]),
      _vm._v(" "),
      _c("span", { staticClass: "icon metamask-icon" }) ])
  },
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("span", { staticClass: "button-login-inner" }, [
      _c("span", [_vm._v("WalletConnect")]),
      _vm._v(" "),
      _c("span", { staticClass: "icon walletconnect-icon" }) ])
  },
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("span", { staticClass: "button-login-inner" }, [
      _c("span", [_vm._v("WalletLink")]),
      _vm._v(" "),
      _c("span", { staticClass: "icon walletlink-icon" }) ])
  } ];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

// Import vue component

// Declare install function executed by Vue.use()
function install(Vue) {
  if (install.installed) { return; }
  install.installed = true;
  Vue.component("ConnectComponent", __vue_component__);
}

// Create module definition for Vue.use()
var plugin = {
  install: install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
var GlobalVue = null;
if (typeof window !== "undefined") {
  GlobalVue = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

export default __vue_component__;
export { install };
